<section class="start-achieving-section">
  <div class="sa-inner">

    <!-- Left: Accent line + Text + Button -->
    <div class="sa-content">
      <div class="sa-accent-line"></div>
      <div class="sa-text-block">
        <h2>{{ "companyHome.ctaTitle" | translate }}</h2>
        <p>{{ "companyHome.ctaDesc" | translate }}</p>
        <a href="#" class="sa-btn">{{ "companyHome.bookDemo" | translate }}</a>
      </div>
    </div>

    <!-- Right: Decorative visual -->
    <div class="sa-visual">
      <div class="sa-circle"></div>
      <div class="sa-stripes"></div>
      <div class="sa-rect-outline"></div>
      <img src="assets/img/Frame 2095588647.png" alt="Hiring professional" class="sa-person-img" />
    </div>

  </div>
</section>
